import React from "react";
import { useParams } from "react-router-dom";
import { Area } from "../models/Area";
import AreasGrid from "../components/AreasGrid";

interface AreaPageProps {
  areas: Area[];
  ratings: Record<string, number>;
  setRatings: React.Dispatch<React.SetStateAction<Record<string, number>>>;
  activeDraftId: number;
  isAreaComplete: (area: Area, ratings: Record<string, number>) => boolean;
  isLoggedIn: boolean;
  noActivePeriod: boolean;
//  requestPeriodid?: number;
}

const AreaPage: React.FC<AreaPageProps> = ({ areas, ratings, setRatings, activeDraftId,isAreaComplete, isLoggedIn, noActivePeriod }) => {
  const { areaId } = useParams();
  const area = areas.find(a => a.areaId === Number(areaId));

  if (!area) {
    return <div>Area not found.</div>;
  }

  if (noActivePeriod) {
    return (
      <div style={{ margin: "40px" }}>
        <h2>Ingen aktiv period</h2>
        <p>Du kan inte visa eller svara på frågor just nu.</p>
      </div>
    );
  }

  return (
    <div style={{ margin: "40px" }}>
      {!isLoggedIn && (
        <div style={{ padding: 24 }}>
          Please sign in to access the questionnaire.
        </div>
      )}
      {isLoggedIn && !noActivePeriod && (
        <AreasGrid
          area={area}
          activeDraftId={activeDraftId}
          ratings={ratings}
          setRatings={setRatings}
          isAreaComplete={isAreaComplete}
         // requestPeriodid={requestPeriodid}
        />
      )}
    </div>
  );
};

export default AreaPage;